import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    AuditData,
    CategoryOptionGroupResponse,
    OptionGroupLocationSaveRequestData,
    OptionGroupSaveRequestData,
    ResponseData,
} from "../../../../graphql/types"

export const fetchOptionGroups = (headers: Record<string, any>): Promise<Maybe<CategoryOptionGroupResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query itemsCategoriesOptionGroups {
                    itemsCategoriesOptionGroups {
                        data {
                            id
                            name
                            displayName
                            displayType
                            price
                            isActive
                            options {
                                id
                                categoryId
                                name
                                kitchenName
                            }
                            addedToItems {
                                id
                                name
                            }
                        }
                        overrides {
                            locationId
                            data {
                                id
                                price
                                isActive
                            }
                        }
                    }
                }
            `,
            operationName: "itemsCategoriesOptionGroups",
        },
    }).then(response => {
        if (response && response.data && response.data.itemsCategoriesOptionGroups) {
            return response.data.itemsCategoriesOptionGroups
        }

        return null
    })

export const optionGroupSave = (
    headers: Record<string, any>,
    data: OptionGroupSaveRequestData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation optionGroupSave($data: OptionGroupSaveRequestData!) {
                    optionGroupSave(data: $data) {
                        success
                    }
                }
            `,
            operationName: "optionGroupSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.optionGroupSave
    })

export const optionGroupLocationSave = (
    headers: Record<string, any>,
    data: OptionGroupLocationSaveRequestData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation optionGroupLocationSave($data: OptionGroupLocationSaveRequestData!) {
                    optionGroupLocationSave(data: $data) {
                      success
                    }
                }
            `,
            operationName: "optionGroupLocationSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.optionGroupLocationSave
    })

export const optionGroupDelete = (
    headers: Record<string, any>,
    id: string,
    auditData: AuditData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation optionGroupDelete($id: String!, $auditData: AuditData) {
                    optionGroupDelete(id: $id, auditData: $auditData) {
                      success
                    }
                }
            `,
            operationName: "optionGroupDelete",
            variables: {
                id: id,
                auditData: auditData,
            },
        },
    }).then(response => {
        return response.optionGroupDelete
    })
